import { useMutation } from "urql";
import { graphql } from "@acto/gql";
import { RescheduleMeetingOccurrenceInput } from "@acto/gql/graphql";
import { useCallback, useState } from "react";

const RescheduleMeetingOccurrenceMutation = graphql(`
  mutation RescheduleMeetingOccurrence($input: RescheduleMeetingOccurrenceInput!) {
    rescheduleMeetingOccurrence(input: $input) {
      id
      __typename
      scheduledDate
      scheduledStartTime
      scheduledEndTime
      occurrenceDate
      client {
        id
        legacyId
        name
        externalReference
        __typename
      }
    }
  }
`);

export function useRescheduleOccurrence() {
  const [result, rescheduleOccurrenceMutation] = useMutation(RescheduleMeetingOccurrenceMutation);
  const [error, setError] = useState<Error | null>(null);

  const rescheduleOccurrence = useCallback(
    async (input: RescheduleMeetingOccurrenceInput) => {
      try {
        const response = await rescheduleOccurrenceMutation({ input });
        if (response.error) {
          throw response.error;
        }
        return response.data?.rescheduleMeetingOccurrence;
      } catch (err: unknown) {
        if (err instanceof Error) {
          setError(err);
          return null;
        } else {
          throw err;
        }
      }
    },
    [rescheduleOccurrenceMutation],
  );

  return { rescheduleOccurrence, result, error };
}
